import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedKidsAthleticsValueModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related kids athletics value"
    okText="ADD KIDS ATHLETICS VALUE"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a kids athletics value"
      queryVariables={{ typeId: FILTER_TYPE.KIDS_ATHLETICS_VALUE.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Kids athletics value is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedKidsAthleticsValueModal.Item = Item;

export default RelatedKidsAthleticsValueModal;
